import moment from "moment";
import "moment/locale/de-at";
import "moment/locale/de";
import "moment/locale/en-gb";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/pt";

export function getLocale(): string {
  return (window.Localize && window.Localize.getLanguage()) || "en-GB";
}

export function localisedMoment(args?: any) {
  return moment(args).locale(getLocale());
}

export function isLocalizeLoaded(): true | null | undefined {
  return window.Localize.loaded;
}
